import { API2_HOST } from 'helpers/urlHelper';
import {
  baseGetWithoutParam,
  basePost
} from 'services/base-services/baseService';

const BASE_URL = `${API2_HOST}/department-spending`;

export const getDepartments = async () => {
  return await baseGetWithoutParam(`${BASE_URL}/departments`);
};

export const getFinancialYears = async () => {
  return await baseGetWithoutParam(`${BASE_URL}/financial-years`);
};

export const getDepartmentSpendingSummary = async (
  department,
  financialYearId
) => {
  return await baseGetWithoutParam(
    `${BASE_URL}/summary?department=${department}&financialYearId=${financialYearId}`
  );
};

export const getDepartmentSpendingSummaryFullYear = async (
  department,
  financialYearId
) => {
  return await baseGetWithoutParam(
    `${BASE_URL}/summary/full-year?department=${department}&financialYearId=${financialYearId}`
  );
};

export const saveDepartmentSpendingLineTypes = async ({
  department,
  financialYearId,
  lines
}) => {
  return await basePost(`${BASE_URL}/line-types`, {
    department,
    financialYearId,
    lines
  });
};

export const getDepartmentSpendingTransactions = async ({
  department,
  accountNumber,
  financialYearId,
  periodId,
  pageNum = 1,
  pageSize = 50
}) => {
  const params = new URLSearchParams({
    department,
    accountNumber,
    financialYearId,
    pageNum,
    pageSize
  });
  if (periodId) params.set('periodId', periodId);

  return await baseGetWithoutParam(`${BASE_URL}/transactions?${params.toString()}`);
};
